import { Transformer } from '@is24at/react-transformers';
import canonicalUrl from './htmlMetaTransformers/canonicalUrl';
import description from './htmlMetaTransformers/description';
import next from './htmlMetaTransformers/next';
import prev from './htmlMetaTransformers/prev';
import robots from './htmlMetaTransformers/robots';
import title from './htmlMetaTransformers/title';
import header from './htmlMetaTransformers/header';

/*
 ** Expect @code args to contain searchQuery and totalHits keys
 */
const resultListHtmlMetaTransformer = (args: any) =>
  new Transformer({
    canonicalUrl,
    description,
    next,
    prev,
    robots,
    header,
    title,
  }).transform(args);

export default resultListHtmlMetaTransformer;
